import { BusinessHoursBuilder } from './business-hours.builder';
var ScheduleBuilder = /** @class */ (function () {
    function ScheduleBuilder() {
        this.schedule = {
            businessHours: new BusinessHoursBuilder().build(),
            downTimes: [],
            timeZone: 'UTC',
        };
    }
    ScheduleBuilder.prototype.businessHours = function (businessHours) {
        this.schedule.businessHours = businessHours;
        return this;
    };
    ScheduleBuilder.prototype.withDayData = function (day, data) {
        this.schedule.businessHours[day] = data;
    };
    ScheduleBuilder.prototype.withDownTimes = function (downTimes) {
        this.schedule.downTimes = downTimes;
        return this;
    };
    ScheduleBuilder.prototype.withTimeZone = function (timeZone) {
        this.schedule.timeZone = timeZone;
        return this;
    };
    ScheduleBuilder.prototype.withOffHoursSmsMessage = function (offHoursSmsMessage) {
        this.schedule.offHoursSmsMessage = offHoursSmsMessage;
        return this;
    };
    ScheduleBuilder.prototype.build = function () {
        return this.schedule;
    };
    return ScheduleBuilder;
}());
export { ScheduleBuilder };
//# sourceMappingURL=schedule.builder.js.map